/**
 * blog/index.js — registry of blog posts. Add a post: create <slug>.js exporting
 * { slug, title, description, date, readMins, body (markdown) } and import it here.
 */
import whyToneBeatsGrammar from './why-email-tone-beats-grammar.js';
import scienceBehindDials from './science-behind-persona-behavioral-dials.js';
import howToSayNo from './how-to-say-no-in-email.js';

export const POSTS = [whyToneBeatsGrammar, scienceBehindDials, howToSayNo]
  .slice()
  .sort((a, b) => (a.date < b.date ? 1 : -1));

export const POST_BY_SLUG = Object.fromEntries(POSTS.map((p) => [p.slug, p]));
